export const show_search_bar = () => (dispatch) => {
  dispatch({
    type: "SHOW_HIDE_SEARCH_BAR",
  });
};
